module.exports = __webpack_public_path__ + "themes/hm/sprite/multi-4@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/hm/sprite/multi-4@2x.png
// module id = 167
// module chunks = 3